import CForm from "./form";
export default CForm;
export type CFormInstance = InstanceType<typeof CForm>;
